import "./../utils/fechas";

import api from "./index";

class CiclosService {
  async getCiclos() {
    //console.log(process.env)
    const ciclos = [];
    const res = await api.get(
      "/event?tags=ciclo"
    );
    for (const data of res.data.data) {
      if (data.isVisible === true && data.promoter === "63186abe9b7b2b1d14217b0c" && new Date(data.startDate).getTime() <= new Date().getTime() &&
      new Date(data.endDate).getTime() >= new Date().getTime()) {
        ciclos.push(data);
      }
    }
    
    return ciclos;
  }
}

export default new CiclosService();
